import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { pageview } from '../utils/analytics';
import * as facebook from '../utils/facebook';
import { useCookieConsent } from './useCookieConsent';

export const usePageTracking = () => {
  const location = useLocation();
  const { hasAnalyticsConsent, hasMarketingConsent } = useCookieConsent();

  useEffect(() => {
    if (hasAnalyticsConsent) {
      pageview(location.pathname + location.search);
    }
    if (hasMarketingConsent) {
      facebook.pageview();
    }
  }, [location, hasAnalyticsConsent, hasMarketingConsent]);
}; 